import { useCallback, useEffect, useState } from 'react';
import { notification } from 'tea-component';
import { manageStudioEyesStatus } from '@sg/services';

export type TInDevChartViewKey = 'titleSpend' | 'headcountRamp';

const DEFAULT_SMALL_CHART_VIEW_STATE: Record<TInDevChartViewKey, boolean> = {
  titleSpend: false,
  headcountRamp: false,
};

export const useInDevChartEyesState = () => {
  const [smallChartViewState, setSmallChartViewState] = useState(
    DEFAULT_SMALL_CHART_VIEW_STATE,
  );

  useEffect(() => {
    const fetchEyesStatus = async () => {
      try {
        const res = await manageStudioEyesStatus({
          op: 'get',
          key: ['title_spend', 'headcount_ramp'],
        });
        const data = res?.data || {};
        const titleSpendEnabled = String(data?.title_spend) === '1';
        const headcountRampEnabled = String(data?.headcount_ramp) === '1';
        setSmallChartViewState({
          titleSpend: titleSpendEnabled,
          headcountRamp: headcountRampEnabled,
        });
      } catch (error) {
        setSmallChartViewState(DEFAULT_SMALL_CHART_VIEW_STATE);
      }
    };

    fetchEyesStatus();
  }, []);

  const updateInDevEyesViewState = useCallback(
    async (viewKey: TInDevChartViewKey, enabled: boolean) => {
      const keyMap = {
        titleSpend: 'title_spend',
        headcountRamp: 'headcount_ramp',
      } as const;
      setSmallChartViewState((prev) => ({
        ...prev,
        [viewKey]: enabled,
      }));
      try {
        await manageStudioEyesStatus({
          op: 'set',
          key: keyMap[viewKey],
          filter: enabled ? '1' : '0',
        });
      } catch (error) {
        notification.error({
          description: 'Failed to save card view setting',
        });
      }
    },
    [],
  );

  return {
    smallChartViewState,
    updateInDevEyesViewState,
  };
};
